import { graphql } from "babel-plugin-relay/macro";

export const ImportedNavigationItemsQuery = graphql`
  query ImportedNavigationItemsQuery(
    $brandId: ID!
    $navigationType: NavigationType
  ) {
    importedNavigationItems(
      brandId: $brandId
      navigationType: $navigationType
    ) {
      menuItems {
        index
        label
        url
        localizations {
          languageCode
          text
          url
        }
        children {
          index
          label
          url
          localizations {
            languageCode
            text
            url
          }
          children {
            index
            label
            url
            localizations {
              languageCode
              text
              url
            }
          }
        }
      }
      shortcutsItems {
        index
        label
        url
        localizations {
          languageCode
          text
          url
        }
        children {
          index
          label
          url
          localizations {
            languageCode
            text
            url
          }
          children {
            index
            label
            url
            localizations {
              languageCode
              text
              url
            }
          }
        }
      }
    }
  }
`;
